import { benchModels } from '../config';
let useProfilematerial = (brand) => benchModels.find(m => m.name === brand).useProfilematerial;

class benchParameters {
    constructor() {
        this.price = -1;
    }
    public brand: string;
    public material: number;
    public profileMaterial: number;
    public shape: string;
    public mirrored: boolean;
    public price: number;
}




class priceStore {
    constructor(priceService) {
        this.priceService = priceService;
    }

    priceService: (brand, shape, mirrored, material, profileMaterial) => { then: (price)=>number};
    prices: benchParameters[] = new Array();

    public getPriceAsync(bench: benchParameters) {
        return new Promise((resolve, reject) =>
        {
            try {
                let priceObject = this.getExistingPriceObject(bench);
                if (priceObject) {
                    console.log("Got benchprice from cache");
                    resolve(priceObject.price);
                }
                else {
                    this.priceService(bench.brand, bench.shape, bench.mirrored, bench.material, bench.profileMaterial).then(price => {
                        this.updatePrice(bench, price);
                        console.log("Got benchprice from service");
                        resolve(price);
                    });
                }                   
            }
            catch (e) {
                reject(e)
            }
        });
    }    
    public updatePrice(bench: benchParameters, price: number) {
        let priceObject = this.getExistingPriceObject(bench);
        if (!priceObject) {
            this.prices.push(bench);
            priceObject = bench;
        }
        priceObject.price = price;
    }
    
    private getExistingPriceObject(bench: benchParameters) {
        if (!bench.brand || !bench.material || !bench.shape) throw "incomplete benchparameters";
        return this.prices.find((p) => {
            return p.brand === bench.brand &&
                p.material === bench.material &&
                p.shape === bench.shape &&
                p.mirrored === bench.mirrored &&
                (p.profileMaterial === bench.profileMaterial || !useProfilematerial(bench.brand));
        });
    } 
}
export default priceStore;